import React from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "../../../design/table";
import { Avatar } from "../../../design/avatar";
import { getInitials } from "../../../utils/string";
import { Case } from "@visitproof/types";

interface CaseTableProps {
  cases: Case[];
}

const CaseTable: React.FC<CaseTableProps> = ({ cases }) => {
  return (
    <Table className="[--gutter:theme(spacing.6)] lg:[--gutter:theme(spacing.10)]">
      <TableHead>
        <TableRow>
            <TableHeader>Identifier</TableHeader>
            <TableHeader>Users</TableHeader>
            <TableHeader>Children</TableHeader>
        </TableRow>
      </TableHead>
      <TableBody>
        {cases.map((caseItem) => (
            <TableRow key={caseItem.id} href={`/case/${caseItem.id}`}>
            <TableCell>{caseItem.identifier}</TableCell>
            <TableCell>
              {caseItem.parents &&
                Object.entries(caseItem.parents).map(([key, value]) => (
                  <div key={key} className="flex items-center gap-2">
                    <Avatar
                      src={value.avatarUrl}
                      className="size-6"
                      initials={getInitials(
                        `${value.firstName} ${value.lastName}`,
                      )}
                    />
                    <span>{`${value.firstName} ${value.lastName}`}</span>
                  </div>
                ))}
            </TableCell>
            <TableCell>
              {caseItem.children &&
                Object.entries(caseItem.children).map(([key, value]) => (
                  <div key={key} className="flex items-center gap-2">
                    <Avatar
                      src={value.avatarUrl}
                      className="size-6"
                      initials={getInitials(
                        `${value.firstName} ${value.lastName}`,
                      )}
                    />
                    <span>{`${value.firstName} ${value.lastName}`}</span>
                  </div>
                ))}
            </TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  );
};

export default CaseTable; 